import React from 'react';
import EmployeeInformationContainer from "../Containers/EmployeeInformationContainer";
import PanelInformationItem from "../../Atoms/Items/PanelInformationItem";

const SocialSecurityPanel = () => {
  return (
    <EmployeeInformationContainer
      title="Seguridad social"
      icon="shield"
    >
      <PanelInformationItem title="Sucursal" text="Seguros sudamérica" />
      <PanelInformationItem title="Fondos de pensión" text="BBVA Colombia" />
      <PanelInformationItem title="EPS" text="Crédito" />
      <PanelInformationItem title="No. de cuenta" text="43 4564 3213" />
    </EmployeeInformationContainer>
  );
};

export default SocialSecurityPanel;
